import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppointmentType } from "./app-web/app-model/dto/common/appointment-type.model";

@Injectable()
export class AppStartupHttpService {

    constructor( private httpClient: HttpClient ) { }

    /**
     * get the User informations
     */
    getUserInfos() {
        return this.httpClient.get<any>( '/getUserInfos' );
    }
    
    /**
     * get the list of authorities
     */
    getAuthorityList() {
        return this.httpClient.get<any>( '/getAuthorityList' );
    }

	/**
     * get the AppointmentType list
     */
    getAppointmentTypeList(): Observable<AppointmentType[]> {
        return this.httpClient.get<AppointmentType[]>( "/appointmentSettings/getAppointmentTypeList" );
    }

}
